import React from 'react'
import { Form } from 'stylist'

const Hidden = ({ field }) => (
  <Form.Input
    key={field.name}
    type="hidden"
    name={field.name}
    value={field.value}
  />
)

export default Hidden



// WEBPACK FOOTER //
// ./src/components/fields/Hidden.js